
@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-3" >


        <spike-field-text formControlName="code" icon ="pi pi-barcode" label="ID Commessa" placeholder="es. Proj-2025-001"></spike-field-text >
        <spike-field-text label="Titolo" formControlName="shortDescription" placeholder="es. Lavorazione metallo..."></spike-field-text>
        <!--
        <spike-field-wrapper label="Etichetta" >
            @if(isFormDisabled()){
                <spike-etiquette [label]="etiquetteLabel()" severity="info"></spike-etiquette>
            }@else {
            <spike-etiquette-list
                noLabelName="default"
                [selectedId]="form().controls['etiquetteId'].value" 
                [etiquetteList]="etiquettesList()" 
                (onSelect)="onSelectEtiquette($event)">
            </spike-etiquette-list>
            }

        </spike-field-wrapper> 
        -->
    </div>
    <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-3" >

        <spike-field-select [initialValue]="organizationStore.getClient(form().controls['clientId'].value)()" formControlName="clientId" icon ="pi pi-id-card" label="Cliente" selectKey="clientId" selectValue="shortDescription" listTitle="Seleziona cliente" detailTitle="dettaglio cliente" placeholder="Seleziona">
            <ng-template #list>
                <spike-organization-list #listRef
                    [modelApi]="clientModelApi"
                    [entityApi]="clientApi"
                    [etiquetteApi]="clientEtiquetteApi"
                    entityKey="clientId">
                </spike-organization-list>
            </ng-template>
        </spike-field-select>
        
        <spike-field-text formControlName="reference" icon ="pi pi-user" label="Referente" placeholder="es. Mario Rossi"></spike-field-text>
        <spike-field-date formControlName="requestDate" icon ="pi pi-calendar" label="Data Richiesta" placeholder="es. 18/12/2025" ></spike-field-date>
        <spike-field-date formControlName="expireDate" icon ="pi pi-calendar-clock" label="Data Scadenza" placeholder="es. 10/01/2026"></spike-field-date>

    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 gap-4 mb-3">
        <spike-field-text-area  label="Note" formControlName="description" placeholder="es. Lavorazione metalli sottili..."> </spike-field-text-area>
    </div>


</form>
}
